module.exports = __webpack_public_path__ + "img/battery-full.2dff1d5f.svg";